module.exports = __webpack_public_path__ + "img/RGS-Karte.ac922939.png";